import { fromJS } from 'immutable';
import * as types from '../constants';
import { settingsDefault } from './db';
import { ThemeData } from './theme-data-reducer/themeData';

const defaultState = fromJS({
  status: false,
  title: 'Trending Product',
  maxProducts: 10,
  slides_preview: 4,
  showHomePages: true,
  showProductPages: true,
  removeProductSold: false,
  showCartPages: true,
  showCollectionPages: true,
  showDesktop: true,
  showMobile: true,
  layoutTheme: 'theme-1',
  settings: settingsDefault,

  getSettingLoading: true,
  saveSettingLoading: false,
  saveSettingResult: 0
});

let res = '';
let settings = {};

const trendingProductReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_TRENDING_PRODUCT_FIELD:
      res = action.payload;
      return state.set(res.field, res.value);

    case types.CHANGE_TRENDING_PRODUCT_SETTINGS:
      res = action.payload;
      return state.setIn(['settings', res.field], res.value);

    case types.GET_SETTING_TRENDING_PRODUCT:
      return state.set('getSettingLoading', true);
    case types.GET_SETTING_TRENDING_PRODUCT_RESULT:
      res = action.res;
      if (res) {
        settings = res.settings ? JSON.parse(res.settings) : settingsDefault;
        if (!res.layout && res.bg_color) {
          settings.bgColor = res.bg_color;
          settings.TitleColor = res.title_color;
          settings.productTitleColor = res.product_title_color;
          settings.priceColor = res.price_color;
          settings.originalPriceColor = res.original_price_color;
        }
        if (!settings.heightDesktopImage) {
          settings.heightDesktopImage = '236';
        }
        if (!settings.widthDesktopImage) {
          settings.widthDesktopImage = '236';
        }
        if (!settings.heightMobileImage) {
          settings.heightMobileImage = '236';
        }
        if (!settings.widthMobileImage) {
          settings.widthMobileImage = '236';
        }
        return state
          .set('status', res.status)
          .set('title', res.title)
          .set('maxProducts', res.max_products)
          .set('showHomePages', res.show_home_pages)
          .set('showProductPages', res.show_product_pages)
          .set('showCartPages', res.show_cart_pages)
          .set('showCollectionPages', res.show_collection_pages)
          .set('showDesktop', res.show_desktop)
          .set('showMobile', res.show_mobile)
          .set('removeProductSold', res.remove_product_sold)
          .set('layoutTheme', res.layout || 'theme-1')
          .set('settings', fromJS(settings))
          .set('slides_preview', res.slides_preview)
          .set('getSettingLoading', false);
      }
      return state.set('getSettingLoading', false);
    case types.CHANGE_TRENDING_PRODUCT_THEME:
      return state
        .set('settings', fromJS(ThemeData[action.theme]))
        .set('layoutTheme', action.theme);
    case types.SAVE_SETTING_TRENDING_PRODUCT:
      return state.set('saveSettingLoading', true).set('saveSettingResult', 0);
    case types.SAVE_SETTING_TRENDING_PRODUCT_RESULT:
      return state.set('saveSettingLoading', false).set('saveSettingResult', action.res);

    case types.CLEAR_DATA_TRENDING_PRODUCT:
      return state.set('getSettingLoading', true).set('saveSettingResult', 0);
    default:
      return state;
  }
};

export default trendingProductReducer;
